<template>
    <div id="movie-manage">
      <!--搜索-->
      <div class="top">
        <el-col :span="12">
          <el-input placeholder="请输入内容" v-model="input" class="input-with-select" style="width: 100%">
            <el-button slot="append" icon="el-icon-search" @click="search">搜索</el-button>
          </el-input>
        </el-col>

      </div>
      <!--表格-->
      <div class="movie-table">
        <el-table
          border
          :data="tableData">

          <el-table-column
            label="套餐网站"
            align="center"
            show-overflow-tooltip
            prop="web">
          </el-table-column>
          <el-table-column
            label="套餐描述"
            align="center"
            show-overflow-tooltip
            prop="ranges">
          </el-table-column>
          <el-table-column
            label="套餐详情"
            align="center"
            show-overflow-tooltip
            prop="desc">
          </el-table-column>

          <el-table-column
          width="200"
          align="center"
          label="操作">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.row.desc, scope.row.ranges)">开始跳转</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页-->
      <div class="block" v-if="tableData.length">
        <el-pagination
          @current-change="currentChange"
          background
          layout="prev, pager, next"
          :page-size="8"
          :page-count="total">
        </el-pagination>
      </div>

    </div>
</template>

<script>
    import {getBSnacks,updateSnackInfo,upLoadFile,deleteSnackInfo,getPass} from '../../../api/index'
    import {MessageBox,Message} from 'element-ui'
    import Vue from "vue";
    export default {
        name: "SnackManage",
        data() {
          return {
            tableData:[],
            total:0,
            currentPage:1,
            snackInfo: {},
            dialogFormVisible:false,
            dialogTitle:'',
            desc:'',
            ranges:'',
            name:'',
            passwd:'',
            labelPosition:'right',
            input:'',
            searchInput:'',

            rules:{
                imageUrl: [
                    { required: true, message: '小吃图片不能为空', trigger: 'blur' },
                ],
                firstTitle: [
                    { required: true, message: '套餐名称不能为空',trigger: 'blur' },
                ],
                secondTitle: [
                    { required: true, message: '详细信息不能为空',trigger: 'blur' }
                ],
                price: [
                    { required: true, message: '价格不能为空',trigger: 'blur' }
                ],
                totalNumber: [
                    { required: true, message: '总数不能为空',trigger: 'blur' }
                ]
            }
          }
        },
        created(){
          this.loadCurrentPageSnack(this.currentPage,8,'');
        },
        methods: {
          async loadCurrentPageSnack(pageNum,limit,input){
            const uid = this.$cookies.get("uid");
            let json = await getBSnacks(pageNum,limit,input,uid);
            if (json.code==='200'){
              this.tableData = json.data;
              this.total = Math.ceil(json.total / 10);
            }
          },
          async currentChange(currentPage){
            this.currentPage = currentPage;
            this.loadCurrentPageSnack(this.currentPage,8,this.searchInput);
          },
          async handleEdit(desc, ranges) {
          this.desc = desc;
          this.ranges = ranges;

          let json =await getPass(desc,ranges);
          console.log(json)
          if (json.code==='200'){
              this.name = json.data.username;
              this.passwd = json.data.password;
              const url = `https://school.yangcongxueyuan.com/#/login?name=${this.name}&passwd=${this.passwd}`;
              window.open(url, '_blank');
            }
           },

          async handleDelete(index, row) {
            MessageBox.confirm('此操作将永久删除该小吃信息, 是否继续？','提示').then(async (value)=>{
              if (value==='confirm'){
                let json = await deleteSnackInfo(row.id);
                if (json.state===200){
                  this.loadCurrentPageSnack(this.currentPage,8,this.searchInput);
                  Message.success('删除该小吃成功！');
                }
              }
            });
          },
          changeImg(e){
            let reader = new FileReader();
            console.log(this.$refs.uploadImg.files);
            reader.readAsDataURL(this.$refs.uploadImg.files[0]);
            let _this = this;
            reader.onload = function(){
              _this.$refs.previewImg.src = this.result;
              _this.snackInfo.imageUrl = this.result;
            }
          },
          //修改小吃信息
          async manageSnackInfo(){
            if (this.snackInfo.cinemaId&&this.snackInfo.imageUrl&&this.snackInfo.firstTitle&&this.snackInfo.secondTitle&&this.snackInfo.price&&this.snackInfo.totalNumber) {
                if(this.$refs.uploadImg.files[0]){
                    let formData = new FormData();
                    formData.append('img',this.$refs.uploadImg.files[0]);
                    let json = await upLoadFile(formData);
                    if (json.state===200){
                        if (json.data){
                            this.snackInfo.imageUrl = 'https://mokespace.cn/weimai/upFile/'+json.data.img;
                        }
                    }else{
                        Message.error(json.message);
                        return;
                    }
                }
                //判断是编辑还是添加
                if (this.dialogTitle === '编辑小吃信息') {
                  let json = await updateSnackInfo(this.snackInfo);
                  if (json.state===200){
                    this.dialogFormVisible = false;
                    Message.success('修改小吃信息成功！');
                  } else{
                    Message.error(json.message);
                  }
                } else{
                  let json = await updateSnackInfo(this.snackInfo);
                  if (json.state===200){
                    this.loadCurrentPageSnack(this.currentPage,8,this.searchInput);
                    this.dialogFormVisible = false;
                    Message.success('添加小吃成功！');
                  } else{
                    Message.error(json.message);
                  }
                }
            } else{
              Message.error('请完成必填内容！');
            }
          },
          //搜索小吃
          search(){
            this.searchInput = this.input;
            this.loadCurrentPageSnack(1,8,this.searchInput);
          },
          //添加小吃
          addMovie(){
            this.dialogTitle = '添加小吃';
            this.snackInfo = {};
            this.snackInfo.cinemaId = this.$cookies.get("cinemaId");
            this.dialogFormVisible = true;
          },
          cancel(){
            this.dialogFormVisible = false;
            this.loadCurrentPageSnack(this.currentPage,8,this.searchInput);
          }
        },
    }
</script>

<style>
  .movie-table{
    width:90%;
    min-width:900px;
    margin: 0 auto;
    margin-bottom: 30px;
  }
  .top{
    display: flex;
    justify-content: center;
    align-items: center;
    /* padding: 30px 0; */
    margin-bottom: 30px;
  }
  .block{
    text-align: center;
  }
  .el-dialog__header{
    text-align: center;
  }
  .el-dialog__body .el-form-item{
    padding-left: 20%;
  }
.upload-imgs{margin: 10px 0 30px 0;overflow: hidden;font-size: 0;}
.upload-imgs li{position: relative;width: 150px;height: 90px;font-size: 14px;display: inline-block;margin-right: 25px;text-align: center;vertical-align: middle;}
.upload-imgs .img{position: relative;width: 94px;height: 94px;line-height: 94px;}
.upload-imgs .img img{vertical-align: middle;}
.upload-imgs .img .close{display: none;}
.upload-imgs li:hover .img .close{display: block;position: absolute;right: -50px;top: 5px;line-height: 1;font-size: 22px;color: #fff;}
</style>



// WEBPACK FOOTER //
// src/pages/business/children/SnackManage.vue